import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=3cc17908&scoped=true&"
import script from "./AspectRatio.vue?vue&type=script&lang=js&"
export * from "./AspectRatio.vue?vue&type=script&lang=js&"
import style0 from "./AspectRatio.vue?vue&type=style&index=0&id=3cc17908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc17908",
  null
  
)

export default component.exports